import {hasLessThan} from "../../utils/strings";
import {CategoryType, MediaMimeTypes} from "../../services/file/file";

export function EditExhibitionForm() {
  this.clientCode = "";
  this.productCode = "";
  this.mediaFiles = [];
  this.imageFiles = [];
  this.removeMediaIDs = [];
}

const orderImages = [
  "Title",
  "Choose language",
  "Language",
  "Listen",
  "Player",
];

const localizedKeys = {
  "Title": "title_page_image",
  "Choose language": "choose_language_page_image",
  "Language": "language_page_image",
  "Listen": "listen_page_image",
  "Player": "player_page_image",
};

EditExhibitionForm.prototype.parseResponse = parseResponse;
EditExhibitionForm.prototype.canAddNewMedia = canAddNewMedia;
EditExhibitionForm.prototype.addNewMediaFile = addNewMediaFile;
EditExhibitionForm.prototype.removeMediaFile = removeMediaFile;
EditExhibitionForm.prototype.updateMediaFile = updateMediaFile;
EditExhibitionForm.prototype.updateImageFile = updateImageFile;
EditExhibitionForm.prototype.validateFields = validateFields;

function parseResponse(response) {
  this.clientCode = response["client_code"];
  this.productCode = response["product_code"];
  const files = response["files"];
  this.imageFiles = files.filter((file) => {
    return file["tag"] === "image" && file["priority"] === 0;
  }).sort(function(lhs, rhs) {
    const lhsIdx = orderImages.findIndex(orderImage => orderImage === lhs["title"]);
    const rhsIdx = orderImages.findIndex(orderImage => orderImage === rhs["title"]);
    return lhsIdx - rhsIdx;
  }).map(imageFile => {
    const title = imageFile["title"];
    return new ImageFile(imageFile["id"], imageFile["priority"], title, imageFile["path"], localizedKeys[title], imageFile["tag"]);
  });
  this.mediaFiles = files.filter((file) => {
    return file["tag"] === "audio" || file["tag"] === "video" || (file["tag"] === "image" && file["priority"] > 0);
  }).sort((lhs, rhs) => {
    return rhs["priority"] - lhs["priority"]
  }).map((audioFile) => {
    return new MediaFile(
      audioFile["id"], 
      audioFile["priority"], 
      audioFile["title"], 
      audioFile["path"], 
      audioFile["tag"]
    );
  });
}

function canAddNewMedia() {
  return this.mediaFiles.length < 4;
}

function addNewMediaFile() {
  const newMediaFile = new  MediaFile(-1, 0, "", "", "");
  this.mediaFiles.push(newMediaFile);
  for (let i = 0; i < this.mediaFiles.length; i++) {
    this.mediaFiles[i].priority = this.mediaFiles.length - i;
  }
}

function removeMediaFile(priority) {
  const targetIndex = this.mediaFiles.findIndex(mediaFile=> mediaFile.priority === priority);
  if (targetIndex === -1) {
    return;
  }
  const targetMediaFile = this.mediaFiles[targetIndex];
  this.mediaFiles.splice(targetIndex, 1);

  for (let i= 0; i < this.mediaFiles.length; i++) {
    this.mediaFiles[i].priority = this.mediaFiles.length - i;
  }

  if (targetMediaFile.id !== -1) {
    this.removeMediaIDs.push(targetMediaFile.id)
  }
}

function updateMediaFile(priority, file, titleName, originName) {
  const targetIndex= this.mediaFiles.findIndex(mediaFile => mediaFile.priority === priority);
  let tag = this.mediaFiles[targetIndex].tag;
  if (file) {
    tag = MediaMimeTypes.getMediaTypeCategoryFromFile(file);
  }
  const supportedTag = tag === CategoryType.AUDIO || tag === CategoryType.VIDEO || tag === CategoryType.IMAGE;

  this.mediaFiles[targetIndex].titleFile = titleName;
  this.mediaFiles[targetIndex].originName = originName;
  this.mediaFiles[targetIndex].file = file;
  this.mediaFiles[targetIndex].tag = tag;
  
  this.mediaFiles[targetIndex].errLocalizedKey = null;
  if (!hasLessThan(titleName, 21)) {
    this.mediaFiles[targetIndex].errLocalizedKey = "file_name_too_long_error";
  } else if (!supportedTag && file) {
    this.mediaFiles[targetIndex].errLocalizedKey = "media_file_require";
  }
}

function updateImageFile(id, file) {
  const targetIndex = this.imageFiles.findIndex(imageFile => imageFile.id === id);
  if (targetIndex === -1) {
    return;
  }
  const tag = MediaMimeTypes.getMediaTypeCategoryFromFile(file);

  this.imageFiles[targetIndex].errLocalizedKey = null;
  this.imageFiles[targetIndex].file = file;
  if (tag !== CategoryType.IMAGE) {
    this.imageFiles[targetIndex].errLocalizedKey = "image_file_require";
    return
  }
}

function validateFields() {
  let error = {};

  const hasEnoughCharsInMediaFileNames = this.mediaFiles.every(mediaFile => {
    return hasLessThan(mediaFile.titleFile, 21);
  });

  const isAllMediaFiles = this.mediaFiles.every(mediaFile => {
    if (!mediaFile.file) {
      return true
    }
    const mediaTypeCategory = MediaMimeTypes.getMediaTypeCategoryFromFile(mediaFile.file);
    return mediaTypeCategory === CategoryType.AUDIO || mediaTypeCategory === CategoryType.VIDEO || mediaTypeCategory === CategoryType.IMAGE;
  });

  const isAllImageFiles = this.imageFiles.every(imageFile => {
    if (!imageFile.file) {
      return true
    }
    return  MediaMimeTypes.getMediaTypeCategoryFromFile(imageFile.file) === CategoryType.IMAGE;
  })

  if (!this.clientCode) {
      error.localizedKey =  "client_code_is_empty";
      return error;
  }

  if (!this.productCode) {
      error.localizedKey = "product_code_is_empty";
      return error;
  }

  const hasMediaFiles = this.mediaFiles.every((mediaFile => {
    return mediaFile.file || mediaFile.id !== -1;
  }));

  const hasEmptyMediaFileTitle = this.mediaFiles.some(audioFile => {
    return !audioFile.titleFile.length
  });

  const mediaFileNames = this.mediaFiles.map(mediaFile => {
    return mediaFile.titleFile.trim();
  }).filter((fileName) => {
    return fileName.length;
  });
  const uniqueMediaFileNames = new Set(mediaFileNames);
  const hasUniqueMediaFileNames = uniqueMediaFileNames.size === mediaFileNames.length;

  if (!hasUniqueMediaFileNames) {
    error.localizedKey = "non_unique_audio_files"
    return error
  }

  if (!hasMediaFiles) {
    error.localizedKey = "audio_files_is_missing";
    return error;
  }

  if (hasEmptyMediaFileTitle) {
    error.localizedKey = "audio_files_has_title_missing"
    return error
  }

  if (!hasEnoughCharsInMediaFileNames) {
    error.localizedKey = "file_name_too_long_error";
    return error
  }

  if (!isAllMediaFiles) {
    error.localizedKey = "media_file_require";
    return error
  }

  if (!isAllImageFiles) {
    error.localizedKey = "image_file_require";
    return error
  }

  return null
}

function MediaFile(id, priority, fileName, path, tag) {
  return {
    id: id,
    priority: priority,
    titleFile: fileName,
    originName: path.split("/").pop(),
    path: path,
    tag: tag,
    file: null,
    errLocalizedKey: null,
    remoteErrorMessage: null,
  };
}

function ImageFile(id, priority, fileName, path, localizedKeys, tag) {
  return {
    id: id,
    priority: priority,
    titleFile: fileName,
    path: path,
    localizedKey: localizedKeys,
    tag: tag,
    file: null,
    remoteErrorMessage: null,
  };
}
